import dayjs from 'dayjs';
/**
 *
 * @param stakedAt
 * @param lockDuration in seconds
 * @returns
 */

export const formatDate = (date = 0) => {
  return dayjs(new Date(date)).format('MMM D YYYY');
};
export const formatTimeLeft = (date = 0) => {
  const hours = Math.round((date - Date.now()) / (60 * 60 * 1000));

  if (hours <= 0) {
    return `0 days 0 hours`;
  }

  const days = Math.floor(hours / 24);
  return `${days} days ${hours - days * 24} hours`;
};